import DataStore from "@/components/GridWidget/DataStore";
import {getParameter} from "@/components/WdiBus/Buttons/data";
import {FieldProps, wdiCore, WdiModalAppProps} from "@/components/WdiControls";
import {WdiModalForm} from "@/components/WdiControls/WdiModalForm";
import {WdiSelect, WdiSelectFormat, WdiTreeSelect} from "@/components/WdiControls/WdiSelect";
import {WdiTable} from "@/components/WdiControls/WdiTable";
import {FormSaDetail} from "@/services/sales/sa";
import {formatter, request, ResponseStatus} from "@/utils/request";
import {ProFormInstance} from "@ant-design/pro-form";
import {message, TableColumnsType} from "antd";
import React, {useEffect, useRef, useState} from "react";
import {paymentMethodDataLoading} from "./data";
import {Product} from "@/services/mdm/product";
import {
  isNeedProductFg,
  PRODUCT_FG_LEVELS,
  showCompany
} from "@/pages/sales/sa/GeneralActivityApply/components/DetailBase";
import {Company} from "@/services/mdm/company";

const ModifyPaymentMethodModalApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();

  const [dataSource, setDataSource] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const columns: TableColumnsType<API.FormSaDetailVo> = [
    {
      title: '行号',
      width: 50,
      dataIndex: 'rowNumber',
    },
    {
      title: '四级使用部门',
      dataIndex: 'boName',
      ellipsis: true,
      width: 200,
    },
    {
      title: '客户',
      dataIndex: 'soldToCode',
      ellipsis: true,
      width: 200,
      render: (_, record) => wdiCore.String.Join(record.soldToCode, record.soldToName),
    },
    {
      title: '门店',
      dataIndex: 'shop',
      ellipsis: true,
      width: 200,
      render: (_, record) => wdiCore.String.Join(record.shopCode, record.shopName),
    },
    {
      title: '产品别',
      dataIndex: 'productBuyNames',
      ellipsis: true,
      width: 240,
    },
    {
      title: '费用项',
      dataIndex: 'ecName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '核算类型',
      dataIndex: 'revenueTypeName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '申请金额',
      dataIndex: 'amount',
      width: 100,
      ellipsis: true,
      render: (value) => wdiCore.Number.AmountToString(value),
    },
    {
      title: '原支付方式',
      dataIndex: 'originalPaymentMethodName',
      ellipsis: true,
      width: 150,
    },
    {
      title: '原指定货补产品别',
      dataIndex: 'originalProductFgNames',
      ellipsis: true,
      width: 150,
    },
    {
      title: '新支付方式',
      dataIndex: 'paymentMethodId',
      width: 120,
      ellipsis: true,
      render: (_: any, record) => {
        return (<WdiSelect  {...{
          value: {value: record.paymentMethodId, label: record.paymentMethodName},
          dataLoading: async () => {
            const paymentMethodOpts = await paymentMethodDataLoading(Number(record.ecId));
            return paymentMethodOpts.map((item) => {
              return {value: item.value, label: item.name};
            });
          },
          onChange: (value, option: any) => {
            const {...newRecord} = record;
            newRecord.paymentMethodId = value;
            newRecord.paymentMethodName = option?.label;
            setDataSource(DataStore.edit(dataSource, newRecord));
          }
        }} style={{width: '100%'}}/>);
      }
    },
    {
      title: '新指定货补产品别',
      dataIndex: 'productFgIds',
      width: 150,
      ellipsis: true,
      render: (value: any, record) => {
        if (record.paymentMethodId && isNeedProductFg(record.paymentMethodId)) {
          return (
            <WdiTreeSelect {...{
              placeholder: "请选择产品别",
              value: value ? [value] : [],
              defaultExpandKeys: value ? [value] : [],
              dataLoading: async (params) => {
                const response = await Product.searchAll(
                  Object.assign({
                    productLevels: PRODUCT_FG_LEVELS.join(),
                    isActive: true,
                    withPermissions: true
                  }, params)
                );
                const {treeData, dict} = FieldProps.TreeSelect.formatTreeData({
                  textField: "codeOrName",
                  valueField: "productId",
                  id: "productId",
                  pId: "parentId",
                  level: "productLevel",
                }, response.data);
                return {treeData, dict};
              },
              onChange: (value) => {
                const {...newRecord} = record;
                newRecord.productFgIds = WdiSelectFormat.getvalue(value);
                newRecord.productFgNames = WdiSelectFormat.gettext(value);
                setDataSource(DataStore.edit(dataSource, newRecord));
              }
            }} style={{width: '100%'}}/>
          )
        } else {
          return <></>;
        }
      }
    },
    {
      title: '新付款公司',
      dataIndex: 'companyCode',
      width: 120,
      ellipsis: true,
      render: (_: any, record) => {
        if (record.paymentMethodId && showCompany(record.paymentMethodId)) {
          return (
            <WdiSelect
              {...{
                placeholder: '请选择公司',
                showSearch: true,
                value: record.companyCode,
                dataLoading: async (params) => {
                  const response = await Company.search(Object.assign({
                    isActive: true,
                  }, params));
                  return response?.data?.map(item => ({value: item.companyCode, label: item.codeOrName}));
                },
                onChange: (value) => {
                  const {...newRecord} = record;
                  newRecord.companyCode = value;
                  setDataSource(DataStore.edit(dataSource, newRecord));
                }
              }} style={{width: '100%'}}
            />
          );
        } else {
          return <></>;
        }
      }
    },
  ]

  useEffect(() => {
    if (props.id) {
      const formSaId = Number(props.id);
      setLoading(true);
      FormSaDetail.getVosForModifyPaymentMethod(formSaId).then((response) => {
        if (response && response.data) {
          const data = response.data;
          data.forEach((item) => {
            item.originalPaymentMethodName = item.paymentMethodName;
            item.originalProductFgNames = item.productFgNames;
          });
          setDataSource(DataStore.init(data));
          setLoading(false);
        }
      });
    }
  }, [props.id]);

  return (
    <WdiModalForm
      formRef={formRef}
      title={props.title}
      visible={props.visible}
      width={1350}
      modalProps={{
        onCancel: () => {
          props.onClose?.();
        },
      }}
      onFinish={async () => {
        if (confirm("确定要进行支付方式的变更吗")) {
          const {data} = props;
          const args = getParameter(data);
          const formSaDetails = dataSource.map(row => ({
            rowNumber: row.rowNumber,
            formSaDetailId: row.formSaDetailId,
            paymentMethodId: row.paymentMethodId,
            productFgIds: row.productFgIds,
            companyCode: row.companyCode,
          }));
          const errorDetail = formSaDetails.find((item) => isNeedProductFg(item.paymentMethodId) && !item.productFgIds);
          if (errorDetail) {
            message.error(`活动明细行号[${errorDetail.rowNumber}]必须填写新指定货补产品别`);
            return;
          }
          args.items.push({name: "formSaDetails", value: JSON.stringify(formSaDetails)});
          const response = await request(data.url, formatter({method: 'POST', body: args}));
          if (response.code == ResponseStatus.SUCCESS) {
            message.success('操作成功');
            if (props.onSave) {
              props.onSave();
            }
          } else {
            message.error(response.message);
          }
        }
      }}
    >
      <WdiTable
        rowKey="formSaDetailId"
        // showPageRows={10}
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        loading={loading}
        allowFilterColumn={true}
      />
    </WdiModalForm>
  );
};

export default ModifyPaymentMethodModalApp;
